module.exports = __webpack_public_path__ + "static/media/codicebolletino.884dfa4a.jpeg";